/**
 * Helper function to create a Redux payload object
 * This object is a standard template for every payload object used in a Redux action(below)
 *
 * It includes:
 * 1. currentApplicant (Targeted person this payload meant for Eg. first/second applcant)
 * 2. payload - Actual data content. (Eg. String, Number, Object, Array...etc)
 */

export function createPayload(currApplicant, data) {
  return {
    currApplicant: currApplicant,
    data: data,
  };
}

//Helper function to return a Redux action object.
export function createReduxAction(actionType, actionPayload) {
  return {
    type: actionType,
    payload: actionPayload,
  };
}
